import Box from "./Box";
import React from "react";

function HalfWidthCol({ children, ...props }) {
  return (
    <Box
      display="grid"
      gridTemplateColumns={["1fr", null, "1fr 1fr", null]}
      gridColumnGap={100}
      gridRowGap={38}
      maxWidth={[null, "80vw", null, null]}
      mx="auto"
      {...props}
    >
      <Box display={["none", null, "initial", null]} />
      <Box>{children}</Box>
    </Box>
  );
}

export default HalfWidthCol;
